define('context/basket',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                products: []
            };
        },

        toJSON: function () {
            var serializedObject = {
                products: []
            };

            this.get('products').forEach(function (basketProduct) {
                serializedObject.products.push({
                    product: basketProduct.product.id,
                    count: basketProduct.count,
                    license: basketProduct.license
                });
            });

            return serializedObject;
        }
    });
});
